import { render, staticRenderFns } from "./SdsSection3CompositionForm.vue?vue&type=template&id=38982b0c"
import script from "./SdsSection3CompositionForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsSection3CompositionForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports